import { initializeApp } from "firebase/app"
import { getAnalytics, isSupported } from "firebase/analytics"
import { getFirestore } from "firebase/firestore"
import { getAuth } from "firebase/auth"
import { getStorage } from "firebase/storage"

const fallbackProjectId = "sealcoat-paving-online"

const envFirebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
}

const hasRequiredFirebaseEnv = Boolean(
  envFirebaseConfig.apiKey &&
  envFirebaseConfig.authDomain &&
  envFirebaseConfig.projectId &&
  envFirebaseConfig.appId
)

const localProjectId = envFirebaseConfig.projectId || fallbackProjectId

const firebaseConfig = hasRequiredFirebaseEnv
  ? envFirebaseConfig
  : {
      apiKey: "local-dev-placeholder-key",
      authDomain: `${localProjectId}.firebaseapp.com`,
      projectId: localProjectId,
      storageBucket: `${localProjectId}.appspot.com`,
      messagingSenderId: "000000000000",
      appId: "1:000000000000:web:localdevplaceholder",
      measurementId: undefined
    }

export const firebaseEnvMissing = !hasRequiredFirebaseEnv

if (firebaseEnvMissing && typeof window !== "undefined") {
  console.warn(
    "Firebase env vars are missing. Running with local placeholder config until VITE_FIREBASE_* values are set."
  )
}

export const firebaseApp = initializeApp(firebaseConfig)
export const db = getFirestore(firebaseApp)
export const auth = getAuth(firebaseApp)
export const storage = getStorage(firebaseApp)

let analyticsInitialized = false

export async function initFirebaseAnalytics() {
  if (analyticsInitialized || typeof window === "undefined" || firebaseEnvMissing) {
    return null
  }

  const supported = await isSupported().catch(() => false)
  if (!supported) {
    return null
  }

  analyticsInitialized = true
  return getAnalytics(firebaseApp)
}
